import { Controller } from "@hotwired/stimulus"
import intlTelInput from "intl-tel-input"

export default class extends Controller {
  static targets = ["input", "hidden", "valid", "error"]

  connect() {
    this.iti = intlTelInput(this.inputTarget, {
      formatOnInit: true,
      nationalMode: true,
      initialCountry: "gb",
      preferredCountries: ["gb", "ie", "us"],
      hiddenInput: "customer[phone_number]"
    })

    if (this.hasHiddenTarget && this.hiddenTarget.value) {
      this.iti.setNumber(this.hiddenTarget.value)
    }

    this.inputTarget.dispatchEvent(new Event("blur"))
  }

  disconnect() {
    if (this.iti) this.iti.destroy()
  }

  validate() {
    const valid = this.iti.isValidNumber()
    this.validTarget.classList.toggle("hidden", !valid)
    this.errorTarget.classList.toggle("hidden", valid)
    return valid
  }

  preventIfInvalid(event) {
    if (!this.validate()) {
      event.preventDefault()
    }
  }
}
